import * as actions from '../actions/actionTypes';
import {updateObject} from '../utility';

const initialState = {
    loading: false,
    error: null,
    errorState: false,
    success: false
}


// const preRegisterUser = (state, action) => {
//     return updateObject(state, null);
// }


const preRegisterSuccess = (state, action) => {
    return updateObject(state, {success: true, errorState: false});
}

const preRegisterFail = (state, action) => {
    return updateObject(state, {error: action.error, errorState: true});
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        // case actions.PREREGISTER_USER: return preRegisterUser(state, action);
        case actions.PREREGISTER_SUCCESS: return preRegisterSuccess(state, action);
        case actions.PREREGISTER_FAIL: return preRegisterFail(state, action);
        default:
            return state;
    }
}

export default reducer;